var render = function (_h,_vm) {var _c=_vm._c;return _c('button',_vm._g(_vm._b({class:_vm.$options.methods.mergeFunctionalRenderContextClasses(_vm.data),attrs:{"type":"button"}},'button',_vm.data.attrs,false),_vm.listeners),[_c('mia-streamline-icon',{staticClass:"w-6 h-6 transition-transform duration-300 transform fill-current ease-out-fast",class:{
      'rotate-0': _vm.props.collapsed,
      'rotate-180': !_vm.props.collapsed,
    },attrs:{"src":"arrow-down-1"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }